import analyticsUtils from '../../helpers/analytics-utils'
import { MarketplaceHit, ProductHit, CategoryHit, ContentfulHit } from './types'

export const makeOnResultClick = (queryText: string) => (
  heading: string,
  hit: ContentfulHit | MarketplaceHit
): void => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SEARCH,
    eventCategory: analyticsUtils.categories.GLOBAL_SEARCH,
    eventAction: analyticsUtils.actions.SEARCH_RESULT_ClICKED,
    eventLabel: queryText,
    globalResultClicked: `${heading}/${
      (hit as ContentfulHit).title ||
      (hit as ProductHit).name ||
      (hit as CategoryHit).displayTitle
    }`,
  })
}

export const logOnClearSearch = (query: string): void => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SEARCH,
    eventCategory: analyticsUtils.categories.GLOBAL_SEARCH,
    eventAction: analyticsUtils.actions.CLICK_TO_CLEAR_SEARCH_KEYWORD,
    eventLabel: query,
  })
}

export const logHideSearch = (query: string): void =>
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SEARCH,
    eventCategory: analyticsUtils.categories.GLOBAL_SEARCH,
    eventAction: analyticsUtils.actions.CLICK_TO_CLOSE_SEARCH,
    eventLabel: query,
  })

export const logShowSearch = (): void =>
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SEARCH,
    eventCategory: analyticsUtils.categories.GLOBAL_SEARCH,
    eventAction: analyticsUtils.actions.CLICK_TO_START_SEARCH,
  })

export const logOnResultsChange = (query: string, numHits: number): void =>
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SEARCH,
    eventCategory: analyticsUtils.categories.GLOBAL_SEARCH,
    eventAction: analyticsUtils.actions.SEARCH_SHOWN,
    eventLabel: query,
    noReturnedResults: numHits,
  })
